/**
 *
 * @authors Your Name (you@example.org)
 * @date    2015-12-28 17:39:04
 * @version $Id$
 */
(function(window, factory) {
    if (typeof exports === 'object') {
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        define(factory);
    } else {
        window.utils = factory();
    }
})(this, function() {
    /**
     * 解析url，获取后带参数
     * */
    var getQueryString = function(name,url) {
        var queryStr = url ? url.substring(url.indexOf('?')) : window.location.search;
        var paramsStr = queryStr.substring(1);
        paramsStr = paramsStr.replace(/\?/g, '&'); //若有过多?号造成异常，则替换
        if (paramsStr) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = paramsStr.match(reg);
            if (r != null) return decodeURI(r[2]);
            return null;
        }
        return null;
    };
    /*发生的请求数*/
    var ajaxCount = 0;
    /*
    @params.url ajax's url
    @params.data ajax's data
    @params.success success callback
    @params.error error callback
    @params.staticsKey 统计key
     */
    var ajax = function(params) {
        ajaxCount++;
        params.data = params.data || {};
        params.data.token = params.data.token || getToken();
        params.data.imei = params.data.imei || getImei();
        params.data.actId = params.data.actId || getActId();
        params.data.r = Math.random();
        if ((typeof $ !== 'undefined') && $.ajax) {
            $.ajax({
                url: params.url,
                dataType: params.dataType || 'jsonp',
                data: params.data,
                timeout: 5000,
                success: function(data) {
                    if (data.resultCode == 1001 && params.staticsKey) {
                        updateStatics(params.staticsKey);
                    } else if (data.resultCode == 1010 && params.showLogin !== false) { /*默认提示登录*/
                        utils.showLogin();
                    }
                    params.success && params.success(data);
                },
                error: function(xhr, errorType, error) {
                    /*非统计接口出现异常，进行统计并提示。*/
                    if (params.noErrorLog !== true) {
                        //updateStatics('error:' + location + ',' + errorType + ',' + error);
                        makeToast('活动遇到点麻烦，请重试一下');
                        if (params.error) {
                            params.error(xhr, errorType, error);
                        }
                    }
                }
            })
        } else {
            if (params.url.indexOf('?') == -1) {
                params.url += '?';
            }
            if (typeof params.success === 'function') {
                var cbName = params.success.name;
                if (window[cbName]) {
                    params.success = cbName;
                } else {
                    var cb = 'c_jsonp' + ajaxCount;
                    window[cb] = params.success;
                    params.success = cb;
                }
            }
            params.url += '&r=' + params.data.r + '&token=' + params.data.token + '&imei=' + params.data.imei + '&callback=' + (params.success || '');
            var script = document.createElement('script');
            script.setAttribute('src', params.url);
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    };
    //是否是原生环境
    var isWithinNative = function() {
        return typeof android === "undefined" ? false : true;
    };
    //是否在游戏平台
    var isWithinGame = function() {
        return isWithinNative() ? (typeof android.downloadByPid === "undefined" ? true : false) : false;
    };
    //是否在商店
    var isWithinShop = function() {
        return isWithinNative() ? (typeof android.downloadByPid === "undefined" ? false : true) : false;
    };
    //调用客户端的方法
    var open = function(packageName) {
        updateStatics(4, packageName);
        return isWithinNative() ? (isWithinGame() ? android.openGame(packageName || '') : android.openApp(packageName || '')) : false;
    };
    //游戏中心下载并安装
    var downloadGameByPackageName = function(packageName, gameName) {
        return isWithinGame() ? android.downloadGameByPackageName(packageName || '', gameName || '') : false;
    };
    /*商店下载
        @param pid = productId
        */
    var downloadGameByPid = function(pid) {
        return isWithinShop() ? android.downloadByPid(pid) : false;
    };
    /*
    @通用下载方法
    @param id 可为包名/masterId/pid 必传
    @param packageName 包名，用做统计使用  非必须
    @gameName 非必须
     */
    var download = function(id, pid, packageName) {
        if (arguments.length == 2) { // args(id,packageName)
            packageName = pid;
        }
        if (isWithinGame()) {
            downloadGameByPackageName(id, packageName);
        } else if (isWithinShop()) {
            /*gameId转pid*/
            if (pid >= Math.pow(10, 8)) {
                pid = pid - Math.pow(10, 8);
            }
            downloadGameByPid(pid - 0);
        }
        if (packageName) {
            updateStatics(3, packageName);
        } else {
            console.warn('包名无效，无法统计下载数据！')
        }
    };
    /*判断是否安装*/
    var isInstalled = function(packageName) {
        if (isWithinNative()) {
            var b = android.isInstalled(packageName || '');
            return b.toString().toLowerCase() === "true";
        }
        return false;
    };
    //复制
    var localCopy = function(text) {
        if (isWithinNative()) {
            android.clipboardText(text);
            makeToast("复制成功");
            return text;
        } else {
            alert('复制' + text + '失败');
        }
    };
    /*
     @desc 获取进度
     @pkg 游戏使用pkg,商店使用pid
     */
    var getProgress = function(pkg, pid) {
        if (isWithinNative() && android.getProgress) {
            if (isWithinGame()) {
                return android.getProgress(pkg);
            } else {
                if (arguments.length == 1) {
                    pid = pkg;

                }
                /*gameId转pid*/
                if (pid >= Math.pow(10, 8)) {
                    pid = pid - Math.pow(10, 8);
                }
                return android.getProgress(pid);
            }
        } else {
            return -1;
        }
    };
    /*
     @desc 获取应用下载状态
     @pkg 游戏使用pkg,老商店使用pid或gameId
     */
    var getAppStatus = function(pkg, pid) {
        if (isWithinGame()) {
            if (isInstalled(pkg)) {
                return 'open';
            } else if (android.getButtonStatus) {
                var status = android.getButtonStatus(pkg);
                if (status == 1 || status == 2) {
                    return 'downloading';
                } else if (status == 3 || status == 5 || status == 6 || status == 12) {
                    return 'pause';
                } else if (status == 4) {
                    return 'waiting';
                } else if (status == 7) {
                    return 'update';
                } else if (status == 11) {
                    return 'installing';
                }else if (status == 0 || status == 9 || status == 10) {
                    return 'download';
                } else {
                    return status + ''; //游戏6.5版本及同期商店版本返回undefined
                }
            } else {
                return 'undefined';
            }
        } else if (isWithinShop() && pid) {
            /*gameId转pid*/
            if (pid >= Math.pow(10, 8)) {
                pid = pid - Math.pow(10, 8);
            }
            var status = android.getButtonStatus(pid - 0);
            if (status == 1) {
                return 'downloading'
            } else if (status == 2) {
                return 'pause'
            } else if (status == 3) {
                return 'download'
            } else if (status == 4) {
                return 'installing'
            } else if (status == 5) {
                return 'open'
            } else {
                return 'undefined';
            }
        } else {
            return 'undefined'
        }
    };
    /*
     @desc 暂停下载
     */
    var pauseDownload = function(pkg, pid) {
        if (isWithinGame() && android.pauseDownload) {
            return android.pauseDownload(pkg);
        } else if (isWithinShop()) {
            /*gameId转pid*/
            if (pid >= Math.pow(10, 8)) {
                pid = pid - Math.pow(10, 8);
            }
            return android.pauseByPid(pid - 0);
        }
        return false;
    };
    /*
     @desc resume download
     */
    var resumeDownload = function(pkg, pid) {
        if (isWithinGame()) {
            return download(pkg);
        } else if (isWithinShop()) {
            /*gameId转pid*/
            if (pid >= Math.pow(10, 8)) {
                pid = pid - Math.pow(10, 8);
            }
            return android.resumeByPid(pid - 0);
        }
        return false;
    };
    //取消下载
    var cancelDownload = function(pkg) {
        if (isWithinNative() && android.cancelDownload) {
            return android.cancelDownload(pkg);
        } else {
            return false;
        }
    };
    //获取网络类型
    var getNetworkType = function() {
        if (isWithinNative() && android.getNetworkType) {
            return android.getNetworkType();
        } else {
            return '';
        }
    };
    //获取应用版本号
    var getAppVersion = function() {
        if (isWithinNative() && android.getAppVersion) {
            return android.getAppVersion();
        } else {
            return -1;
        }
    };
    //打开新的webview
    var redirect = function() {
        var title = '',
            url = '',
            type = '';
        if (arguments.length == 1) {
            url = arguments[0]
        } else {
            title = arguments[0];
            url = arguments[1];
            type = arguments[2] || '';
        }
        var path = url.indexOf('http') == 0 ? '' : /.*\//.exec(location);
        if (isWithinNative() && android.openWebView) {
            android.openWebView(title, path + url, type);
        } else {
            location = url;
        }
    };
    //信息提示
    var makeToast = function(message) {
        return isWithinNative() ? android.makeToast(message) : alert(message);
    };
    var alert = function(text) {
        window.alert(text);
    };
    /*
         @desc 统计数据
         @key 类型
         @param type  1：pv，3：下载，4:打开，5，参与
         @param arg1 为packageName或其他
         */
    var updateStatics = function(key) {
        var settings = {
            'event': 'app.inteface',
            'tags': {
                'accept-encoding': 'gzip',
                'name': '603'
            }
        };
        settings.tags['gc30'] = getToken();
        settings.tags['imei'] = getImei();
        //渠道号,apk-游戏中心  rs-软件商店
        settings.tags['env'] = getEnv() == 'gamecenter' ? 'apk' : (getEnv() == 'market' ? 'rs' : (getEnv() ? getEnv() : 'browser'));
        settings.tags['model'] = getModel();
        /*actId注入时挂在全局*/
        var actId = getActId() || -1;
        if (parseFloat(actId) < 0 || isNaN(parseFloat(actId))) { /*不统计非法actId*/
            return;
        }
        settings.tags['id'] = actId;
        settings.timestamp = new Date().getTime();
        if (typeof key === 'number') {
            settings.tags['type'] = key;
        } else {
            settings.tags['type'] = key, key = (key + '').toLowerCase();
            switch (key) {
                case '1':
                case 'pv':
                    settings.tags['type'] = 1;
                    break;
                case '3':
                case 'download':
                    settings.tags['type'] = 3;
                    break;
                case '4':
                case 'open':
                    settings.tags['type'] = 4;
                    break;
                case '5':
                case 'join':
                    settings.tags['type'] = 5;
                    break;
                default:
                    settings.tags[key] = 'customeKey';
            }
        }
        settings.tags['obj'] = arguments[1] || '';
        ajax({
            url: 'https://epoch.cdo.oppomobile.com/soporcollect/appevent/activite?data=' + encodeURIComponent(JSON.stringify(settings)),
            noErrorLog: true,
            success: arguments[2] || function(data) {
                console.log('已统计:' + settings.tags['type'] +　',' + settings.tags['obj']);
            }
        })
    };
    //获取imei
    var getImei = function() {
        var imei = '';
        if (isWithinNative() && android.getImei) {
            imei = android.getImei(); /*用native方法拿imei*/
        } else if (isWithinGame()) {
            var p = {
                clz: "KekeGameClient",
                method: "getEnv",
                args: {
                    "key": "imei"
                }
            };
            imei = prompt(JSON.stringify(p));
        }
        if (!imei) {
            imei = getQueryString('imei') || sessionStorage.getItem('imei'); /*query str拿imei 或从session中拿*/
        }
        if (!imei) {
            imei = localStorage.getItem('imei') || '';
        }
        if (!imei) {
            imei = new Date().getTime() + Math.floor(Math.random() * 10000); /*如果不存在，生成随机字符串*/
            localStorage.setItem('imei', imei);
        }
        sessionStorage.setItem('imei', imei);
        return imei;
    };
    //get token
    var getToken = function() {
        var token = '';
        if (isWithinNative() && android.getLoginInfo) {
            token = decodeURIComponent(android.getLoginInfo().split(";")[0]);
        } else if (isWithinNative() && android.getToken) {
            token = android.getToken();
        }
        //如果token依然无法获取
        if (!token) {
            var param = getQueryString('param') || getQueryString('token');
            if (param) {
                token = param.split(';')[0];
            }
        }
        if (!token) {
            token = sessionStorage.getItem('token');
            token == 'null' ? token = null : '';
        }
        /*为了使cdn缓存发挥，将token保存在session中*/
        sessionStorage.setItem('token', token || '');
        return token;
    };
    //机型
    var getModel = function() {
        var model = '';
        if (isWithinGame()) {
            model = android.getLoginInfo().split(";")[1]
        } else if (isWithinShop()) {
            model = android.getMobileName();
        } else {
            model = 'browser';
        }
        return model;
    };
    var showLogin = function() {
        if (isWithinGame()) {
            android.doStartLogin(true);
        } else if (isWithinShop()) {
            if (getVersionCode() == 4552 || getVersionCode() == 14552) { /*此版本登录后一直有showLoading的bug，改为提示*/
                makeToast('您还未登陆，请到“我”的模块登陆后再来参加活动吧。');
            } else {
                android.startLogin();
            }
        } else {
            alert('你所在环境无法调起登录功能');
        }
    };
    var isLogin = function() {
        if (isWithinNative() && android.isLogin) {
            var b = android.isLogin();
            return b.toString().toLowerCase() === "true";
        } else {
            var token = getToken(); //未登录情况，在商店中 token = -1,在游戏中心token=0
            return token == -1 ? false : ( !! token);
        }
    };
    var getVersionCode = function() {
        if (isWithinNative() && android.getVersionCode) {
            return android.getVersionCode();
        } else if (isWithinNative() && android.callNativeApi) {
            var obj = {
                "api": "tool",
                "type": "tool_get_version_and_platform"
            };
            return JSON.parse(android.callNativeApi(JSON.stringify(obj)) || {}).versioncode;
        }
        return 0;
    };
    /*
     *@desc 跳转详情
     *
     *@param masterId(appId)
     */
    var openDetail = function(id) {
        if (isWithinNative() && android.openActivity) {
            if (isWithinGame()) {
                android.openActivity('oap://gc/dt?id=' + id);
            } else if (isWithinShop()) {
                android.openActivity('oap://mk/dt?id=' + id);
            }
        } else {
            console.warn('not support!');
        }
    };
    /*
     *@param 获取所有环境
     */
    var getEnv = function() {
        if (isWithinNative() && android.callNativeApi) {
            var obj = {
                "api": "tool",
                "type": "tool_get_version_and_platform"
            };
            return JSON.parse(android.callNativeApi(JSON.stringify(obj))).platform;
        } else if (isWithinShop()) { //老商店
            return 'market'
        } else if (isWithinGame()) { //老游戏中心
            return 'gamecenter';
        }
        return 'browser';
    };
    /*
    获取actId
     */
    var getActId = function() {
        var actId = getQueryString('actId') || sessionStorage.getItem('actId') || window.actId || localStorage.getItem('actId') || '';
        sessionStorage.setItem('actId', actId);
        localStorage.setItem('actId', actId); //webview 打开不共享sessionStorage
        return actId;
    };
    /**
     * @param fileList type:Array desc:文件URL列表
     * @param onFinish 文件列表加载完成后
     * @param processor 文件列表加载进度
     * */
    var require = function(options) {
        var _options = {
            fileList: [],
            onFinish: function() {},
            processor: function(percentage) {}
        };
        _options = $.extend(_options, options || {});
        var fileNum = _options.fileList.length,
            total = fileNum,
            percentage = 0;
        _options.fileList.forEach(function(val, index) {
            add(val);
        })
        var _checkProcess = function() {
            _options.processor(1 - (--fileNum) / total);
            if (fileNum == 0) {
                _options.onFinish();
            }
        }

            function add(file) {
                var e, type = file.substring(file.lastIndexOf('.') + 1);
                if (/^(png|jpg|jpeg|gif)$/.test(type)) {
                    e = new Image();
                    e.src = file;
                    e.onerror = e.onload = function() {
                        _checkProcess();
                    }
                } else {
                    $.get(file, function() {
                        _checkProcess();
                        if (type === 'css') {
                            $('head').append('<link rel="stylesheet" type="text/css" href="' + file + '">');
                        }
                    })
                }
            }
    };
    /*
      @desc 返回当前时间  
     */
    var getTime = function() {
        return new Date().getTime();
    };
    window.utils = {
        getQueryString: getQueryString,
        ajax: ajax,
        isWithinNative: isWithinNative,
        isWithinGame: isWithinGame,
        isWithinShop: isWithinShop,
        open: open,
        downloadGameByPackageName: downloadGameByPackageName,
        downloadGameByPid: downloadGameByPid,
        download: download,
        isInstalled: isInstalled,
        localCopy: localCopy,
        getProgress: getProgress,
        getAppStatus: getAppStatus,
        pauseDownload: pauseDownload,
        resumeDownload: resumeDownload,
        cancelDownload: cancelDownload,
        getNetworkType: getNetworkType,
        getAppVersion: getAppVersion,
        redirect: redirect,
        makeToast: makeToast,
        updateStatics: updateStatics,
        getImei: getImei,
        getToken: getToken,
        getModel: getModel,
        showLogin: showLogin,
        isLogin: isLogin,
        getVersionCode: getVersionCode,
        openDetail: openDetail,
        getEnv: getEnv,
        getActId: getActId,
        require: require,
        getTime: getTime
    };
    /*平台统计*/
    (function() {
        var platform = getQueryString('platform');
        if (platform) {
            updateStatics(7, 'pv_' + platform);
        }
    })();
    /*前端防劫持*/
    (function() {
        var supportIframe = !! getQueryString('supportIframe'),
            isEmbed = !! getQueryString('isEmbed');
        /*设置不可见*/
        if (!supportIframe) {
            var head = document.getElementsByTagName('head')[0],
                style = document.createElement('style');
            style.innerHTML = 'iframe{display:none!important;}';
            head.appendChild(style);
        }
        /*被插入script或iframe的位置不确定，采取定时移除*/
        var t = setInterval(function() {
            var iframes = document.getElementsByTagName('iframe');
            for (var i = 0; i < iframes.length; i++) {
                var tmp = iframes[i];
                if(tmp.getAttribute('src').indexOf('oppomobile.com') != -1){
                    continue;//跳过内部广告采集
                }else if (!(tmp.getAttribute('ignore') && supportIframe)) {
                    tmp.parentNode.removeChild(tmp);
                    updateStatics(7, 'hijack');
                    console.warn('The iframe will be removed,please set the param (supportIframe = true) and the iframe attribute(ignore = true) to make it work!');
                }
            }
        }, 200);
        setTimeout(function() {
            clearInterval(t);
        }, 3000)
        /*劫持页面以iframe展示真正的页面*/
        if (!isEmbed) {
            if (window.top.location !== window.location) {
                updateStatics(7, 'hijack-out');
                makeToast('Current page is embeded,please set the param (isEmbed = true) to make it work!');
                window.top.location.href = window.location.href;
            }
        }
    })();
    return window.utils;
});
/*移动端active效果*/
document.body.addEventListener('touchstart', function() {});